"use strict";

exports.__esModule = true;
exports.default = object;
var _getLength = _interopRequireDefault(require("./_getLength.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object(list, values) {
  var result = {};
  for (var i = 0, length = (0, _getLength.default)(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}